exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main_web_banner[data-v-78cad1d5]{width:100%;height:100%}.main_web_banner .banner_web[data-v-78cad1d5]{width:100%!important}.main_web_banner .banner_mobile[data-v-78cad1d5]{width:100%!important;display:none}@media only screen and (max-width:880px){.main_web_banner .banner_mobile[data-v-78cad1d5]{display:block}.main_web_banner .banner_web[data-v-78cad1d5]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78cad1d5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/public/WebBanner.vue
// module id = 759
// module chunks = 2